<template>
  <div
    class="stock-status-indicator"
    :class="[
      {
        'stock-status-indicator--green': statusColor === 'green',
        'stock-status-indicator--light-green': statusColor === 'light-green',
        'stock-status-indicator--yellow': statusColor === 'yellow',
        'stock-status-indicator--red': statusColor === 'red',
        'stock-status-indicator--blue': statusColor === 'blue',
        'stock-status-indicator--purple': statusColor === 'purple'
      }
    ]"
  />
</template>

<script setup>
defineProps({
  statusColor: {
    type: String,
    default: ''
  }
})
</script>

<style lang="postcss" scoped src="./StockStatusIndicator.css" />
